module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("1 and 2 Thessalonians")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("AB")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Anchor Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("AnBib")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Analecta Biblica")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("ANF")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Ante-Nicene Fathers")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("ANTC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Abingdon New Testament Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("AThR")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Anglican Theological Review")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("BBR")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Bulletin for Biblical Research")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("BCH")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Bulletin de correspondance hellénique")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("BDAG")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Walter Bauer et al. "), _c('i', [_vm._v("A Greek-English Lexicon of the New Testament and Other Early Christian Literature.")]), _vm._v(" 3rd ed. Revised and edited by Frederick William Danker. Chicago: University of Chicago Press, 2000.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("BDF")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("F. Blass, A. Debrunner, and R. W. Funk. "), _c('i', [_vm._v("A Greek Grammar of the New Testament and Other Early Christian Literature.")]), _vm._v(" Chicago: University of Chicago Press, 1961")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("BSac")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Bibliotheca Sacra")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("CBQ")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Catholic Biblical Quarterly")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("CEB")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Common English Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("CEV")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Contemporary English Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("ConBNT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Coniectanea biblica: New Testament Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("CTJ")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Calvin Theological Journal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("CurTM")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Currents in Theology and Mission")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("ÉBib")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Études bibliques")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("EDNT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Exegetical Dictionary of the New Testament.")]), _vm._v(" Edited by Horst Balz and Gerhard Schneider. 3 vols. Grand Rapids: Eerdmans, 1990–93.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("EKKNT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Evangelisch-katholischer Kommentar zum Neuen Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("ESV")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("English Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('i', [_vm._v("EvQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Evangelical Quarterly")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("ExAud")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Ex Auditu")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("GNT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Good News Translation")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("GNT"), _c('sup', [_vm._v("4")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Greek New Testament,")]), _vm._v(" 4th rev. ed.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("HBT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Horizons in Biblical Theology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("HCSB")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Holman Christian Standard Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("HNT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Handbuch zum Neuen Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("HTR")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Harvard Theological Review")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("IBC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Interpretation: A Bible Commentary for Teaching and Preaching")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("ICC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("International Critical Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("IJST")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("International Journal of Systematic Theology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("Int")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Interpretation")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("IVPNTC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("InterVarsity Press New Testament Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JBL")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Journal of Biblical Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JETS")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Journal of the Evangelical Theological Society")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JSNT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Journal for the Study of the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("JSNTSup")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Journal for the Study of the New Testament Supplement Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JSOT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Journal for the Study of the Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JSPL")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Journal for the Study of Paul and His Letters")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JTI")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Journal of Theological Interpretation")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JTS")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Journal of Theological Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("JTSA")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Journal of Theology for South Africa")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("KJV")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("King James Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("LNTS")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Library of New Testament Studies")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("LXX")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Septuagint")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("mng.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("meaning")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("MS(S)")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("manuscript(s)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NA"), _c('sup', [_vm._v("28")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Nestle-Aland "), _c('i', [_vm._v("Greek New Testament,")]), _vm._v(" 28th ed.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NASB")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New American Standard Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NBBC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New Beacon Bible Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NCB")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New Century Bible Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NET")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New English Translation")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NICNT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New International Commentary on the New Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NIB")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New Interpreter’s Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("NIDB")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("New Interpreter’s Dictionary of the Bible.")]), _vm._v(" Edited by Katherine Doob Sakenfield. 5 vols. Nashville: Abingdon, 2006–9.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NIGTC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New International Greek Testament Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NIV")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New International Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NJB")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New Jerusalem Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("NLT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New Living Translation")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("NovT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Novum Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("NPNF")]), _c('sup', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Nicene and Post-Nicene Fathers,")]), _vm._v(" Series 1")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("NPNF")]), _c('sup', [_vm._v("2")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Nicene and Post-Nicene Fathers,")]), _vm._v(" Series 2")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NRSV")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New Revised Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NSBT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New Studies in Biblical Theology")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NTOA")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Novum Testamentum et Orbis Antiquus")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("NT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("New Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("NTS")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("New Testament Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("OBT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Overtures in Biblical Theology")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("OG")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Old Greek")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("OT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Old Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("PBM")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Paternoster Biblical Monographs")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("PNTC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Pillar New Testament Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("ProEccl")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Pro Ecclesia")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("PTR")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Princeton Theological Review")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("RBL")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Review of Biblical Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("RevExp")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Review and Expositor")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("RSV")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Revised Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("SB")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Sammelbuch griechischer Urkunden aus Aegypten")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("SBLDS")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("SHBC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Smyth & Helwys Bible Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("SJT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Scottish Journal of Theology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("SNTSMS")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Society of New Testament Studies Monograph Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("SP")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Sacra Pagina")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("STJ")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Second Temple Judaism")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("SUNT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Studien zur Umwelt des Neuen Testaments")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("TDNT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Theological Dictionary of the New Testament.")]), _vm._v(" Edited by Gerhard Kittel and Gerhard Friedrich. Translated by Geoffrey W. Bromiley. 10 vols. Grand Rapids: Eerdmans, 1964–76.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("THNTC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Two Horizons New Testament Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("TNIV")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Today’s New International Version")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("TS")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Theological Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("TT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Theology Today")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("TynBul")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Tyndale Bulletin")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("VT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Vetus Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("WBC")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Word Biblical Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("WesTJ")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Wesleyan Theological Journal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_vm._v("WUNT")]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Wissenschaftliche Untersuchungen zum Neuen Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("WW")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Word and World")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_vm._v("ZBK")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Zürcher Bibelkommentare")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("ZNW")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft and die Kunde der älteren Kirche")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("ZST")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left1"
  }, [_c('i', [_vm._v("Zeitschrift für systematische Theologie")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa08521c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 75
// module chunks = 0